export default __webpack_public_path__ + "static/media/loader.84cf1e24.gif";